import { useRef, useState, useEffect } from "react";
import { toast, Toaster } from "react-hot-toast";
import axios from "../api/axiosClient";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PageHeader from "../components/ui/PageHeader";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import CustomTable from "../components/ui/CustomTable";
import CustomInput from "../components/ui/CustomInput";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useLoading } from "../components/LoadingContext";
import { handleError, errorToast } from "../services/serviceBase";
import moment from "moment";
import CustomGridCell from "../components/ui/CustomGridCell";

const SalePriceLists = (props) => {
  const intl = useIntl();
  const { setLoading } = useLoading();

  const company = useSelector((state) => state.common.company);

  const [tableHeigth, setTableHeigth] = useState(600);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [articlesInError, setArticlesInError] = useState([]);

  const [openModalUploadFile, setopenModalUploadFile] = useState(false);
  const handleOpenModalUploadFile = () => {
    setopenModalUploadFile(true);
    setArticlesInError([]);
  };
  const handleCloseModalUploadFile = () => {
    setopenModalUploadFile(false);
    setArticlesInError([]);
  };

  const fileRef = useRef(null);

  const [selectedEnvirorments, setSelectedEnvirorments] = useState([]);

  const resizeTable = () => {
    var headerHeight = document.querySelector("#header").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight = pageHeight - headerHeight - 150;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  const handleDeleteFile = (e, row) => {
    setLoading(true);
    axios
      .delete("/SalePriceLists/" + row.idSalePriceListHead)
      .then((response) => {
        setLoading(false);
        setSelectedEnvirorments([]);
        getListData();
        toast.success("Deleted!");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleUploadFileFromTable = (e, row) => {
    setSelectedEnvirorments([
      { envCode: row.envCode, idJDAEnvironment: row.idJDAEnvironment },
    ]);
    handleOpenModalUploadFile();
  };

  const getColumns = () => {
    setColumns([
      {
        field: "envDescr",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Description" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 400,
      },
      {
        field: "currencyCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Currency" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 100,
      },
      {
        field: "beginOfValidity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.StartDate" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 150,
        valueFormatter: (value) => {
          var startDate = "";
          if (value !== null) {
            startDate = moment(value).format("YYYY-MM-DD");
          }
          return startDate;
        }
      },
      {
        field: "endOfValidity",
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 150,
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.EndDate" })}
          </Typography>
        ),
        valueFormatter: (value) => {
          var endDate = "";
          if (value !== null) {
            endDate = moment(value).format("YYYY-MM-DD");
          }
          return endDate;
        }
      },
      {
        field: "upload",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        flex: 1,
        minWidth: 50,
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.UploadFile" })}
          </Typography>
        ),
        renderCell: (params) => {
          if (
            params.row.endOfValidity !== null &&
            params.row.beginOfValidity !== null
          ) {
            return (
              <IconButton
                aria-label="go"
                size="large"
                color="primary"
                disabled={true}
              >
                <UploadIcon />
              </IconButton>
            );
          }
          return (
            <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(event) => handleUploadFileFromTable(event, params.row)}
            >
              <UploadIcon />
            </IconButton>
          );
        },
      },
      {
        field: "delete",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        flex: 1,
        minWidth: 50,
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.DeleteFile" })}
          </Typography>
        ),
        renderCell: (params) => {
          if (
            params.row.endOfValidity === null &&
            params.row.beginOfValidity === null
          ) {
            return (
              <IconButton
                aria-label="go"
                size="large"
                color="primary"
                disabled={true}
              >
                <DeleteIcon />
              </IconButton>
            );
          }
          return (
            <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(event) => handleDeleteFile(event, params.row)}
            >
              <DeleteIcon />
            </IconButton>
          );
        },
      },
      {
        field: "envCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Envirorment" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 120,
      },
    ]);
  };

  useEffect(() => {
    getColumns();
  }, [rows, tableHeigth, company]);

  const handleMultiCurrency = () => {
    if (selectedEnvirorments.length == 0) {
      toast.error(intl.formatMessage({ id: "SalePrice.NoEnvSelected" }));
      return;
    }

    handleOpenModalUploadFile();
  };

  const handleUploadFile = () => {
    setLoading(true);
    let params = new URLSearchParams();
    if (company !== undefined && company !== "") {
      params.append("IdCompany", `${company}`);
    }
    selectedEnvirorments.forEach((env) => {
      params.append("idEnvironmentList", env.idJDAEnvironment);
    });

    if (startDate !== undefined && startDate !== "" && startDate !== null) {
      var date = startDate.toISOString().substring(0, 10);
      params.append("beginOfValidity", date);
    }

    if (endDate !== undefined && endDate !== "" && endDate !== null) {
      var date = endDate.toISOString().substring(0, 10);
      params.append("endOfValidity", date);
    }

    params.append("username", `website`);

    params.append("withQty", props.withQty);
    params.append("discriminant", props.discriminant);

    const data = new FormData();
    data.append("file", fileRef.current.files[0]);
    var url = "/SalePriceLists" + "?" + params.toString();
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        setSelectedEnvirorments([]);
        fileRef.current.value = "";
        getListData();
        handleCloseModalUploadFile();
        toast.success("Uploaded!");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl, () => {
          errorToast(error, intl);
          var articlesInError = JSON.parse(error.response.data.title);
          setArticlesInError(articlesInError);
        });
      });
  };

  useEffect(() => {
    getColumns();
  }, [rows, company]);

  useEffect(() => {
    getListData();
    setSelectedEnvirorments([]);
  }, [props.discriminant, props.withQty, company]);

  const getListData = () => {
    setLoading(true);
    let params = new URLSearchParams();
    if (company !== undefined && company !== "") {
      params.append("IdCompany", `${company}`);
    }
    params.append("withQty", props.withQty);
    params.append("discriminant", props.discriminant);

    axios
      .get("/SalePriceLists", { params })
      .then((response) => {
        setLoading(false);
        setRows(response.data);
        resizeTable();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const onSelectionFunc = (ids) => {
    var envs = [];
    ids.forEach((id) => {
      var row = rows.find((row) => row.idJDAEnvironment === id);
      envs.push({
        envCode: row.envCode,
        idJDAEnvironment: row.idJDAEnvironment,
      });
    });
    setSelectedEnvirorments(envs);
  };

  return (
    <Box>
      {props.discriminant == "MarkDown" && !props.withQty ? (
        <PageHeader title={intl.formatMessage({ id: "SalePrice.MarkDown" })} />
      ) : (
        ""
      )}
      {props.discriminant == "MarkDown" && props.withQty ? (
        <PageHeader
          title={intl.formatMessage({ id: "SalePrice.MarkDownQty" })}
        />
      ) : (
        ""
      )}
      {props.discriminant == "FullPrice" && !props.withQty ? (
        <PageHeader title={intl.formatMessage({ id: "SalePrice.FullPrice" })} />
      ) : (
        ""
      )}
      {props.discriminant == "FullPrice" && props.withQty ? (
        <PageHeader
          title={intl.formatMessage({ id: "SalePrice.FullPriceQty" })}
        />
      ) : (
        ""
      )}
      {props.discriminant == "Packaging" && props.withQty ? (
        <PageHeader
          title={intl.formatMessage({ id: "SalePrice.PackagingQty" })}
        />
      ) : (
        ""
      )}
      {props.discriminant == "Packaging" && !props.withQty ? (
        <PageHeader
          title={intl.formatMessage({ id: "SalePrice.Packaging" })}
        />
      ) : (
        ""
      )}

      <Modal
        open={openModalUploadFile}
        onClose={handleCloseModalUploadFile}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "40%",
            // top: '200px',
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            width: 500,
            p: 4,
            borderRadius: "5px",
          }}
        >
          <PageHeader
            title={intl.formatMessage({ id: "General.UploadFile" })}
          />
          <Box id="modal-modal-description" sx={{ mt: 2 }}>
            <Typography>
              {intl.formatMessage({ id: "SalePrice.SelectedEnvs" })}:{" "}
              {selectedEnvirorments.map((env) => env.envCode).join(", ")}
            </Typography>
            <Box sx={{ mt: 1 }}>
              <CustomInput
                labelText={intl.formatMessage({ id: "General.StartDate" })}
                type="date"
                valueRef={startDate}
                setValue={setStartDate}
                textCol={3}
                inputCol={6}
              />
              <CustomInput
                labelText={intl.formatMessage({ id: "General.EndDate" })}
                type="date"
                valueRef={endDate}
                setValue={setEndDate}
                textCol={3}
                inputCol={6}
              />
              <CustomInput
                labelText={intl.formatMessage({
                  id: "General.SelectExcelFile",
                })}
                type="file"
                valueRef={fileRef}
                acceptedContentTypes="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
            </Box>
            <Grid container sx={{ mt: 1 }}>
              <Grid item md={8}></Grid>
              <Grid item md={4}>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleUploadFile}
                >
                  {intl.formatMessage({ id: "General.Upload" })}
                </Button>
              </Grid>
            </Grid>
            <Box sx={{ mt: 1, width: "100%" }}>
              {props.withQty && articlesInError.length > 0 ? (
                <Box>
                  <Typography sx={{ color: "red" }}>
                    {intl.formatMessage({ id: "Error.SKUInError" })}
                  </Typography>
                  <Paper sx={{ overflow: "hidden" }}>
                    <TableContainer sx={{ maxHeight: 300 }}>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              {intl.formatMessage({ id: "General.Sku" })}
                            </TableCell>
                            {articlesInError != null &&
                            articlesInError != undefined &&
                            articlesInError.length > 0 &&
                            articlesInError[0].EnvCode !== "" &&
                            articlesInError[0].EnvCode !== null ? (
                              <TableCell>
                                {intl.formatMessage({
                                  id: "General.Envirorment",
                                })}
                              </TableCell>
                            ) : (
                              ""
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {articlesInError.map((row) => {
                            return (
                              <TableRow>
                                <TableCell>{row.Barcode}</TableCell>
                                {row.EnvCode !== "" && row.EnvCode !== null ? (
                                  <TableCell>{row.EnvCode}</TableCell>
                                ) : (
                                  ""
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Box>
              ) : (
                ""
              )}
              {!props.withQty && articlesInError.length > 0 ? (
                <Box>
                  <Typography sx={{ color: "red" }}>
                    {intl.formatMessage({ id: "Error.SKUInError" })}
                  </Typography>
                  <Paper sx={{ overflow: "hidden" }}>
                    <TableContainer sx={{ maxHeight: 300 }}>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              {intl.formatMessage({ id: "General.StyleCode" })}
                            </TableCell>
                            <TableCell>
                              {intl.formatMessage({ id: "General.FabricCode" })}
                            </TableCell>
                            <TableCell>
                              {intl.formatMessage({ id: "General.ColorCode" })}
                            </TableCell>
                            <TableCell>
                              {intl.formatMessage({ id: "General.Variant" })}
                            </TableCell>
                            <TableCell>
                              {intl.formatMessage({
                                id: "General.VariantType",
                              })}
                            </TableCell>
                            {articlesInError != null &&
                            articlesInError != undefined &&
                            articlesInError.length > 0 &&
                            articlesInError[0].EnvCode !== "" &&
                            articlesInError[0].EnvCode !== null ? (
                              <TableCell>
                                {intl.formatMessage({
                                  id: "General.Envirorment",
                                })}
                              </TableCell>
                            ) : (
                              ""
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {articlesInError.map((row) => {
                            return (
                              <TableRow>
                                <TableCell>{row.StyleCode}</TableCell>
                                <TableCell>{row.FabricCode}</TableCell>
                                <TableCell>{row.ColorCode}</TableCell>
                                <TableCell>{row.Variant}</TableCell>
                                <TableCell>{row.VariantType}</TableCell>
                                {row.EnvCode !== "" && row.EnvCode !== null ? (
                                  <TableCell>{row.EnvCode}</TableCell>
                                ) : (
                                  ""
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Box>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Box>
      </Modal>

      <div id="body">
        <Grid container sx={{ mt: 0.5, mb: 0.5 }}>
          <Grid item md={10}></Grid>
          <Grid item md={2}>
            <Button
              size="small"
              variant="contained"
              sx={{ width: "100%" }}
              className="apeLigthBlueBackground"
              onClick={handleMultiCurrency}
            >
              {intl.formatMessage({ id: "SalePrice.UploadMultiCurrency" })}
            </Button>
          </Grid>
        </Grid>
        <CustomTable
          columns={columns}
          rows={rows}
          id={"idJDAEnvironment"}
          rowHeight={60}
          headerHeight={50}
          tableHeight={tableHeigth}
          enableSelection={true}
          setSelectedRows={onSelectionFunc}
        />
      </div>
    </Box>
  );
};

export default SalePriceLists;
